import React from 'react';
import { motion } from 'framer-motion';
import '../assets/styles/Certifications.scss';
import { FaAward, FaCertificate, FaMedal, FaTrophy } from 'react-icons/fa';
import { SectionHeader } from './ui';

interface Certification {
    id: number;
    title: string;
    issuer: string;
    year: string;
    icon: 'award' | 'certificate' | 'medal' | 'trophy';
    color: string;
}

const certificationsData: Certification[] = [
    {
        id: 1,
        title: "Top Rated Plus Badge",
        issuer: "Upwork",
        year: "2026",
        icon: 'trophy',
        color: '#14a800'
    },
    {
        id: 2,
        title: "Level Two Seller",
        issuer: "Fiverr",
        year: "2023",
        icon: 'award',
        color: '#1DBF73'
    },
    {
        id: 3,
        title: "Android Compose Camp Conductor",
        issuer: "Google Developer Student Club BVP",
        year: "2022",
        icon: 'certificate',
        color: '#4285F4'
    },
    
    {
        id: 4,
        title: "Mobile App Hackathon Winner",
        issuer: "KATH 18, University of Gujrat",
        year: "2018",
        icon: 'medal',
        color: '#FFD700'
    },
];

function Certifications() {
    const getCertIcon = (icon: string) => {
        switch (icon) {
            case 'award': return <FaAward />;
            case 'certificate': return <FaCertificate />;
            case 'medal': return <FaMedal />;
            case 'trophy': return <FaTrophy />;
            default: return <FaAward />;
        }
    };

    return (
        <section className="certifications-section" id="certifications">
            <div className="certifications-section__container">
                <SectionHeader title="Certifications & Awards" align="left" />
                <div className="certifications-section__grid">
                    {certificationsData.map((cert, index) => (
                        <motion.div
                            key={cert.id}
                            className="cert-card"
                            style={{ '--cert-color': cert.color } as React.CSSProperties}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-60px' }}
                            transition={{ duration: 0.4, delay: index * 0.08 }}
                        >
                            <div className="cert-card__top">
                                <div className="cert-card__icon">
                                    {getCertIcon(cert.icon)}
                                </div>
                                <span className="cert-card__year">{cert.year}</span>
                            </div>
                            <h4 className="cert-card__title">{cert.title}</h4>
                            <p className="cert-card__issuer">{cert.issuer}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Certifications;
